export default {
  addVariable: 'Добавить переменную',
  defaultVariableText: 'Выберите переменную',
  checkCompliance: 'Проверить соответствие',
  templateMatches: 'Текст соответствует шаблону',
  templateNotMatches: 'Текст не соответствует шаблону',
};
